import { useGetGenreCreativeAggregateQuery } from '../../../api/ua-insights'
import { useUAInsightsScope } from './useUAInsightsNavigation'

/**
 * Fetches the aggregated Creative Ads view for a genre, used as the target
 * side of the game-vs-genre comparison dialog. Returns `undefined` when
 * `genreId` is null so callers can pass the URL param straight in without
 * branching at the call site.
 *
 * Pass the source game's id as `excludeGameId` whenever this hook is used for
 * a source-vs-genre comparison: when the source belongs to the target genre,
 * its own creatives are removed from the aggregate so the comparison reads as
 * "source vs the rest of the genre" instead of the source being counted on
 * both sides of the matchup. When the source isn't in the genre the parameter
 * is a no-op.
 */
export const useGenreCreativeAggregate = (genreId: string | null, excludeGameId?: string | null) => {
  const { networkId, month } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetGenreCreativeAggregateQuery(
    {
      genreId: genreId ?? '',
      excludeGameId: excludeGameId ?? undefined,
      networkId: networkId ?? undefined,
      month: month ?? undefined,
    },
    { skip: !genreId }
  )
  return { data, isLoading: isFetching, isError, refetch }
}
